import { axiosInstance } from "../../utils";

const actions = {
    FETCH_SUPPLIERS_REQUESTED: 'FETCH_SUPPLIERS_REQUESTED',
    FETCH_SUPPLIERS_SUCCEEDED: 'FETCH_SUPPLIERS_SUCCEEDED',
    FETCH_SUPPLIERS_FAILED: 'FETCH_SUPPLIERS_FAILED',

    APPROVE_SUPPLIER_REQUESTED: 'APPROVE_SUPPLIER_REQUESTED',
    APPROVE_SUPPLIER_SUCCEEDED: 'APPROVE_SUPPLIER_SUCCEEDED',
    APPROVE_SUPPLIER_FAILED: 'APPROVE_SUPPLIER_FAILED',

    FETCH_ORDERS_ANALYTICS_REQUESTED: 'FETCH_ORDERS_ANALYTICS_REQUESTED',
    FETCH_ORDERS_ANALYTICS_SUCCEEDED: 'FETCH_ORDERS_ANALYTICS_SUCCEEDED',
    FETCH_ORDERS_ANALYTICS_FAILED: 'FETCH_ORDERS_ANALYTICS_FAILED',

    FETCH_REVENUE_REQUESTED: 'FETCH_REVENUE_REQUESTED',
    FETCH_REVENUE_SUCCEEDED: 'FETCH_REVENUE_SUCCEEDED',
    FETCH_REVENUE_FAILED: 'FETCH_REVENUE_FAILED',

    approveSupplier: (id = undefined) => {
        return {
            type: actions.APPROVE_SUPPLIER_REQUESTED,
            payload: id
        }
    },

    fetchSuppliers: (params = undefined) => {
        return {
            type: actions.FETCH_SUPPLIERS_REQUESTED,
            payload: params
        }
    },

    fetchOrdersAnalytics: (params = undefined) => {
        return {
            type: actions.FETCH_ORDERS_ANALYTICS_REQUESTED,
            payload: params
        }
    },

    fetchRevenueAnalytics: (params = undefined) => {
        return {
            type: actions.FETCH_REVENUE_REQUESTED,
            payload: params
        }
    },

    getSuppliers: async (params = undefined) => {
        const url = `users`;

        try {
            const suppliers = await axiosInstance.get(url,{ params });
            return suppliers.data;
        } catch (error) {
            throw error;
        }
    },

    getOrdersAnalytics: async (params = undefined) => {
        const url = `/dashboard/orders`;

        try {
            const ordersAnalytics = await axiosInstance.get(url,{ params });
            return ordersAnalytics.data;
        } catch (error) {
            throw error;
        }
    },

    getRevenueAnalytics: async (params = undefined) => {
        const url = `/dashboard/revenue`;

        try {
            const ordersAnalytics = await axiosInstance.get(url,{ params });
            return ordersAnalytics.data;
        } catch (error) {
            throw error;
        }
    },

    approveSupplierApi: async (id = undefined) => {
        const url = `users/${id}`;

        try {
            const approveSupplier = await axiosInstance.put(url, {verified: true});
            return approveSupplier.data;
        } catch (error) {
            throw error;
        }
    },

};
export default actions;
